import memo from 'memoize-one';
import _get from 'lodash/get';

function getMenuType(menuEntry) {
  return _get(menuEntry, 'type', '').toString().toLowerCase();
}

const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

const isUrl = memo(path => reg.test(path));

export {
  isUrl,
  getMenuType,
};
